<template>
  <div>
    <v-btn
      v-if ="func != null"
      class="btnVR rounded-lg"
      solo
      depressed
      :height="size"
      :color="color"
      v-on:click='func'
      block
      style="padding:0"
      :disabled="disabled"
    >
      <v-icon v-if="mdi != null" left style="margin:0 0 0 10px; " :size="iconSize()"  color="#f2f2f2">{{mdi}}</v-icon>
      <span v-else-if ="icon == 'VR'" style="margin:0 0 0 10px; ">
        <!-- <v-img :src="require(`@/assets/${icon};`)" width="30" height="30"/> -->
        <v-img src="@/assets/icon_VR_W.svg" width="30" height="30"/>
      </span>
      <span class="btn_text" style="padding-left: 10px; margin-right:auto;">{{title}}</span>
      <!-- <span style="margin:0 10px 0 10px; ">
        <v-img src="@/assets/icon_VR_W.svg" width="30" height="30"/>
      </span> -->
      <v-icon right style="margin:0 10px 0 0; " :size="size-20" color="#f2f2f2">{{svgPath_Outbound}}</v-icon>
    </v-btn>
    <v-card-text  v-if="caution != null" >{{caution}}</v-card-text>
  </div>
</template>

<script>
// https://www.nxworld.net/10-css-hover-fill-animation.html
import { mdiMagnify, mdiArrowRightCircle } from '@mdi/js'
export default {
  data () {
    return {
      svgPath_Magnify: mdiMagnify, // Material Design Icon
      svgPath_Outbound: mdiArrowRightCircle // Material Design Icon
      // imagesrc: require(`@/assets/${this.icon};`)
    }
  },
  props: {
    title: {
      type: String,
      required: false
    },
    func: {
      type: Function,
      required: false,
      default: null
    },
    size: {
      type: Number,
      required: false
    },
    icon: {
      type: String,
      required: false,
      default: null
    },
    mdi: {
      type: String,
      required: false,
      default: null
    },
    color: {
      type: String,
      required: false,
      default: '#191919'
    },
    caution: {
      type: String,
      required: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    loadImg () {
      // const images = require.context('../assets/', false, /\.svg$|\.png$|\.jpg$/)
      // return images('./' + this.icon)
      return require(`@/assets/${this.icon};`)
    },
    iconSize () {
      if (this.size >= 55) {
        return 40
      } else {
        return 30
      }
    }
  }
}
</script>

<style scoped>
.btnVR {
  color: #f2f2f2;
  font-size:18px;
  font-weight: 900;
}
.theme--dark.v-btn {
  background-color:#191919;
}
.v-card__text {
  padding: 6px 16px 0px;
  /* color: #DFFF00; */
  /* color: #00EEFF; */
  font-weight: 900;
  font-size: 15px;
}

.theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined){
  background-color:#d7d7d7 !important;
}
.v-btn--disabled >>> .btn_text,
.v-btn--disabled >>> .btn_icon {
  color: #ffffff;
}
.theme--light.v-btn.v-btn--disabled .v-icon, .theme--light.v-btn.v-btn--disabled .v-btn__loading {
  color: #ffffff !important;
}
</style>
